// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { ThemeProps, createGlobalStyle } from 'styled-components';

import { StyledReset } from './StyledReset';
import lightTheme from './light';
import { hexTorgba } from '../../utils/style';

export const GlobalStyles = createGlobalStyle`
  ${StyledReset};

  :root {
    --sp-header-height: 2.75rem;
    --sp-login-header-height: 4rem;
    --pc-header-height: 3.5rem;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    font-family: ${(props) => props.theme.fonts.body};
  }

  html {
    font-size: ${(props: ThemeProps<typeof lightTheme>) =>
      props.theme.fontSizes.baseFontSize};
    background-color: ${(props) => props.theme.globalStyle.bgd};
    color: ${(props) => props.theme.globalStyle.text};
  }

  html.striped-bg {
    background-size: auto auto;
    background-image: ${(props) => props.theme.globalStyle.stripedBgd};
  }

  html.white-bg {
    background-color: ${(props) => props.theme.colors.greys.white};
  }

  html.additional-font {
    *,
    *::before,
    *::after {
      font-family: ${(props) => props.theme.fonts.lp};
    }
  }

  html.full-height {
    div#__next {
      display: grid;
      grid-template-rows: auto 1fr auto;
      grid-template-columns: 1fr;
    }
  }

  html,
  body {
    height: 100%;
    overscroll-behavior: none;
  }

  body.fullscreen {
    touch-action: none;
  }

  body.scroll-lock {
    position: fixed;
    width: 100%;
    overflow: hidden;
    transform: translateZ(0);
    top: 0;
    left: 0;
  }

  div#__next {
    min-height: 100%;
  }

  a {
    color: ${(props) => props.theme.colors.primary.main};
  }

  img {
    vertical-align: bottom;
  }

  picture {
    max-width: 100%;
    display: block;
  }

  ::-webkit-scrollbar {
    height: 1rem;
    width: 0.5rem;
  }

  ::-webkit-scrollbar:horizontal {
    height: 0.5rem;
    width: 1rem;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 9999px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.greys.grey20};
    border-color: ${(props) => props.theme.colors.greys.grey20};
    border-radius: 9999px;
    border-width: 1px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) =>
      hexTorgba(props.theme.colors.greys.grey20, 0.7)};
  }

  [hidden] {
    display: none !important;
  }

  .sp-only {
    display: initial;
  }

  .pc-only {
    display: none;
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    .sp-only {
      display: none;
    }

    .pc-only {
      display: initial;
    }
  }
`;

export default GlobalStyles;
